import React from 'react'
import { useTranslation } from 'react-i18next'

import AnimationTalking2Guys from 'assets/animations/talking-2-guys.json'
import AnimationThinkingGuy from 'assets/animations/thinking-guy.json'
import AnimationTalking3Guys from 'assets/animations/talking-3-guys.json'
import LandingButton from 'components/Landing/LandingButton'
import LottiePlayer from 'components/Shared/LottiePlayer'

function Method() {
  const { t } = useTranslation()
  return (
    <div className="method">
      <h2 className="method__title">{t('landing.method.title')}</h2>
      <p className="method__description">{t('landing.method.description')}</p>
      <LandingButton
        samePage
        className="mt-2 mb-4"
        to="landing-contact-us"
        text={t('landing.method.more')}
        variant="desktop"
      />
      <div className="method__animation-list">
        <LottiePlayer
          animationData={AnimationTalking2Guys}
          className="method__animation method__animation--two-guys"
        />
        <LottiePlayer
          animationData={AnimationThinkingGuy}
          className="method__animation method__animation--one-guys"
        />
        <LottiePlayer
          animationData={AnimationTalking3Guys}
          className="method__animation method__animation--three-guys"
        />
      </div>
      <LandingButton
        samePage
        className="mt-2"
        to="landing-contact-us"
        text={t('landing.method.more')}
        variant="mobile"
      />
    </div>
  )
}

export default Method
